// extracted by mini-css-extract-plugin
export default {"stats":"stats_stats__ksP6M","table":"stats_table__ZCcYb","result":"stats_result__-ux7o"};